interface ScopedEnvironmentRow {
    groupKey: string;
    environmentIds: string[];
}

export function buildScopedEnvironmentIdsByGroup(rows: ScopedEnvironmentRow[]): Map<string, Set<string>> {
    const result = new Map<string, Set<string>>();
    for (const { groupKey, environmentIds } of rows) {
        if (!result.has(groupKey)) {
            result.set(groupKey, new Set());
        }

        const scopedEnvironmentIds = result.get(groupKey);
        for (const envId of environmentIds) {
            scopedEnvironmentIds?.add(envId);
        }
    }
    return result;
}
